export const MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

export const BUSINESS_UNITS = [
    "Fresh Baltics",
    "Fresh Denmark",
    "Fresh Finland",
    "LU Australia",
    "LU BeNeFrItEs",
    "LU Denmark",
    "LU FIBA",
    "LU Germany",
    "LU Hungary",
    "LU Norway",
    "LU Poland",
  "LU Romania",
    "LU Sweden",
    "LU UK",
    "LU USA"
];

export const CATEGORY_OPTIONS = [
    'All Categories',
    'Cakes & Desserts',
    'Danish Pastry',
    'Fast Food',
  'French Pastry',
    'Other',
    'Rye Bread',
    'Savouries',
    'Soft Dough',
    'Wheat Bread'
];
